module.exports = "<dispatchers-page></dispatchers-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/dispatchers.html
// module id = 1578
// module chunks = 0